var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrush = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m14.666 13.334 4 4m-5.374 5.375 15.212-15.21A2.83 2.83 0 1 0 24.5 3.498L9.29 18.709M8.666 28A4.666 4.666 0 1 0 4 23.334c0 .888-.337 1.742-.944 2.39A1.334 1.334 0 0 0 4 28z"
})));
export default SvgBrush;